import FormController from "./form_controller"
import Logger from '../lib/logger'

/**
 * Quotes Form Controller - Extends form controller with quote-specific functionality
 */
export default class extends FormController {
  static targets = ["quoteId", "formContent"]
  static values = {
    ...FormController.values,
    quoteId: Number
  }

  connect() {
    super.connect()
    this.entityTypeValue = 'quote'
    Logger.debug('QuotesFormController connecting', { quoteId: this.quoteIdValue })
  }

  // Handle debounced search
  debouncedSearch(event) {
    // Clear any existing timer
    clearTimeout(this.debounceTimer)
    
    // Start a new timer
    // Was `this.debounceDelayValue` — FormController (the parent) declares `debounceMs`, not
    // `debounceDelay`; the undeclared value read as `undefined`, and `setTimeout(fn, undefined)`
    // runs at essentially 0ms, silently defeating the debounce.
    this.debounceTimer = setTimeout(() => {
      this.search(event)
    }, this.debounceMsValue)
  }

  // Submit the form
  search(event) {
    // Reset to first page when performing a new search
    const pageField = this.element.querySelector('input[name="page"]')
    if (pageField) pageField.value = 1
    
    // Submit the form
    this.element.requestSubmit()
  }

  // Filter providers based on selected state
  filterProviders(event) {
    // This would be implemented to fetch providers for the selected state
    // and update the provider select options
    Logger.debug('Filtering providers for state', { state: event.target.value })
    
    // In a real implementation, you might:
    // 1. Fetch providers for the selected state via AJAX
    // 2. Update the provider select options
    // 3. Reset the selected provider if it's no longer valid
  }

  // Reset the customer field
  resetCustomer(event) {
    const customerInput = this.element.querySelector('[data-quote-search-target="customer"]')
    if (customerInput) {
      customerInput.value = ''
      this.search(event)
    }
  }

  // Handle form reset
  resetForm() {
    // Reset all form fields
    this.element.reset()
    
    // Reset any custom state
    if (this.hasProviderSelectTarget) {
      this.providerSelectTarget.selectedIndex = 0
    }
    if (this.hasPendingProviderSelectTarget) {
      this.pendingProviderSelectTarget.selectedIndex = 0
    }
    
    // Submit the form to show all results
    this.search()
  }
}
